
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetomahabaleshwar() {



    const cardData =
    {
        keyword: ' Pune to Mahabaleshwar Cab',
        heading: 'Prince Cabs: Pune to Mahabaleshwar Cab',
        headingDescription: 'Prince Cabs offers reliable Pune to Mahabaleshwar Cab services, perfect for family vacations, weekend trips, corporate outings, and sightseeing tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride through the scenic Western Ghats. With professional chauffeurs, on-time pickups, and flexible schedules, we make your Pune to Mahabaleshwar journey smooth and hassle-free. Choose Prince Cabs’ trusted cab service from Pune to Mahabaleshwar for affordability, convenience, and comfort.',

        top: 'Top Places to Visit in Mahabaleshwar with Prince Cabs',

   "topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is the most popular attraction in Mahabaleshwar, surrounded by lush greenery and hills. Visitors enjoy boat rides, horse riding, and lakeside snacks. The lakefront is especially lively during evenings with families and couples. In monsoon and winter, mist adds a magical charm. Street food stalls selling corn and strawberries are a delight. Venna Lake is the perfect family-friendly spot."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is famous for its strawberry produce, jams, and juices. The garden features a café serving strawberry cream, pizzas, and mocktails. It hosts the annual Strawberry Festival during summer, attracting thousands of tourists. Visitors can shop for chocolates, syrups, and organic products. Its green lawns and open-air seating create a relaxing vibe. Mapro Garden is Mahabaleshwar’s foodie paradise."
  },
  {
    "title": "Arthur’s Seat Point",
    "description": "Arthur’s Seat, often called the Queen of Points, offers breathtaking views of the deep Savitri River Valley and the Konkan region. The spot is known for its optical illusion where objects thrown down appear to float. It is a favorite for photographers and nature lovers. The viewpoint is especially stunning at sunset. Trekking to the point adds adventure to the visit. Arthur’s Seat is Mahabaleshwar’s most scenic viewpoint."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a unique rock formation resembling an elephant’s trunk. Located near Kate’s Point, it offers panoramic views of the Sahyadri ranges and valleys. The location is calm and ideal for photography. Clouds often hover low here during monsoon, creating dreamy scenery. Tourists love combining it with nearby viewpoints. Elephant’s Head Point is Mahabaleshwar’s natural wonder."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort, built by Chhatrapati Shivaji Maharaj in 1656, is a historic landmark near Mahabaleshwar. The fort is famous for the battle between Shivaji Maharaj and Afzal Khan. Visitors explore bastions, temples, and panoramic valley views. The Bhavani Mata Temple adds spiritual importance. Trekking to the fort is popular among adventure seekers. Pratapgad is Mahabaleshwar’s pride in Maratha history."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is one of the most beautiful waterfalls in Mahabaleshwar. The falls cascade from a height of 600 feet into the valley below. The viewpoint offers breathtaking monsoon scenery. Visitors enjoy trekking trails leading to the spot. The waterfall looks spectacular during the rainy season with mist all around. Lingmala is Mahabaleshwar’s refreshing natural retreat."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point, also called Sunrise Point, is the highest point in Mahabaleshwar at 4,710 feet. It offers a 360-degree view of the surrounding valleys and hills. Tourists flock here early morning to witness the sunrise. The site also provides beautiful sunset views. It is an excellent spot for photography. Wilson Point is the best vantage point in Mahabaleshwar."
  },
  {
    "title": "Kate’s Point and Needle Hole Point",
    "description": "Kate’s Point, named after the daughter of Sir John Malcolm, offers stunning valley views. Nearby Needle Hole Point has a natural rock formation with a hole resembling a needle. Both spots are great for photography and sightseeing. Monsoon adds misty beauty to the views. They are among the most-visited tourist points in Mahabaleshwar. Kate’s Point is a blend of history and natural charm."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple, dedicated to Lord Shiva, is an ancient pilgrimage site. Built in the 16th century, it features a swayambhu linga made of black stone. The temple is highly revered and visited by devotees year-round. Its Hemadpanti-style architecture adds to its spiritual charm. Surrounded by peaceful landscapes, it provides a calm retreat. Mahabaleshwar Temple is a sacred gem of the hill station."
  },
  {
    "title": "Panch Ganga Temple",
    "description": "The Panch Ganga Temple marks the origin of five holy rivers: Krishna, Venna, Koyna, Savitri, and Gayatri. Built in the 13th century by Raja Singhandeo, it holds immense religious importance. Devotees believe bathing in its waters purifies the soul. The temple’s architecture is simple yet spiritually powerful. Surrounded by hills, it is a serene spot for pilgrims. Panch Ganga Temple is Mahabaleshwar’s spiritual landmark."
  },
  {
    "title": "Tapola (Mini Kashmir)",
    "description": "Tapola, located 25 km from Mahabaleshwar, is known as ‘Mini Kashmir.’ It is famous for its backwaters of the Koyna Dam. Tourists enjoy boating, kayaking, and camping by the lakeside. The lush greenery and mountains create a scenic escape. Adventure enthusiasts also trek in nearby forests. Tapola is Mahabaleshwar’s offbeat and peaceful getaway."
  },
  {
    "title": "Connaught Peak",
    "description": "Connaught Peak, formerly Mount Olympia, is the second-highest peak in Mahabaleshwar. It offers panoramic views of Krishna Valley, Venna Lake, and Panchgani. The viewpoint is popular among trekkers and nature enthusiasts. Sunsets here are mesmerizing with golden skies. It is less crowded, making it peaceful for visitors. Connaught Peak is Mahabaleshwar’s hidden gem."
  },
  {
    "title": "Table Land, Panchgani",
    "description": "Table Land in nearby Panchgani is Asia’s second-longest mountain plateau. It stretches across 6 km and is famous for horse riding, paragliding, and film shoots. The plateau offers stunning valley views and sunsets. During monsoon, it becomes a lush green carpet. Tourists often combine it with a Mahabaleshwar trip. Table Land is a natural wonder of the region."
  },
  {
    "title": "Elephant Point Strawberry Farms",
    "description": "Mahabaleshwar is famous for its strawberry farms, producing 85% of India’s strawberries. Visitors enjoy farm tours and pluck fresh strawberries. Strawberry cream and milkshakes are local delicacies. The farms are most vibrant during winter and early summer. Tourists shop for jams, jellies, and syrups. Strawberry farms are Mahabaleshwar’s sweet delight."
  },
  {
    "title": "Arthur’s Seat Valley Trek",
    "description": "For adventure seekers, trekking through Arthur’s Seat Valley is an unforgettable experience. The trail passes through forests, cliffs, and river views. It offers close encounters with Sahyadri’s rugged beauty. The trek is especially popular during monsoon with mist and waterfalls. Photography enthusiasts love the panoramic landscapes. It is Mahabaleshwar’s adventurous escape."
  }
],


      
  "services": [
    {
      "name": "Pune to Mahabaleshwar Innova Crysta Cab",
      "description": "Comfortable and spacious Innova Crysta cabs from Pune to Mahabaleshwar, ideal for family and group travel. Enjoy a smooth ride with experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Mahabaleshwar Taxi",
      "description": "Book a reliable taxi from Pune to Mahabaleshwar for a hassle-free outstation trip. Choose from a variety of car options at affordable rates with professional drivers."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Package",
      "description": "Affordable Pune to Mahabaleshwar cab packages including round trip and sightseeing. Perfect for weekend getaways and short vacations with family or friends."
    },
    {
      "name": "Pune to Mahabaleshwar Cab for 2 Days",
      "description": "Plan a 2-day trip from Pune to Mahabaleshwar with our comfortable cab service. Ideal for overnight stays and local sightseeing, with flexible pickup and drop timings."
    },
    {
      "name": "Pune to Mahabaleshwar Cab Service",
      "description": "Trusted cab services from Pune to Mahabaleshwar offering timely pickups, clean cars, and courteous drivers. Book one-way or round trip with ease."
    },
    {
      "name": "Pune to Mahabaleshwar Car",
      "description": "Hire a car from Pune to Mahabaleshwar for personal or group travel. Enjoy a stress-free journey in a clean and air-conditioned vehicle with an experienced driver."
    },
    {
      "name": "Pune to Mahabaleshwar Etios Taxi Fare",
      "description": "Check our competitive fares for Etios taxi service from Pune to Mahabaleshwar. Ideal for small families or solo travelers looking for a budget-friendly option."
    },
    {
      "name": "Pune to Mahabaleshwar Innova Cab",
      "description": "Spacious Innova cabs available from Pune to Mahabaleshwar for a luxurious travel experience. Suitable for groups and families wanting comfort and convenience."
    },
    {
      "name": "Pune to Mahabaleshwar Dzire Cab",
      "description": "Hire a Dzire cab for your Pune to Mahabaleshwar trip at affordable prices. Enjoy a comfortable and economical ride with experienced chauffeurs."
    },
    {
      "name": "Pune to Mahabaleshwar Round Trip Taxi",
      "description": "Book a round trip taxi from Pune to Mahabaleshwar for a complete travel solution. Includes return fare, waiting time, and flexible journey planning."
    },
    {
      "name": "Pune to Mahabaleshwar One Way Cab",
      "description": "One-way cab service from Pune to Mahabaleshwar at budget-friendly rates. Ideal for tourists, students, and professionals looking for reliable drop service."
    },
    {
      "name": "Pune to Mahabaleshwar Family Cab",
      "description": "Spacious family cabs from Pune to Mahabaleshwar for a comfortable journey with your loved ones. Enjoy scenic views and a safe ride with experienced drivers."
    },
    {
      "name": "Pune to Mahabaleshwar Affordable Taxi",
      "description": "Affordable taxi services for Pune to Mahabaleshwar travel with multiple car options. Get great value without compromising comfort or safety."
    },
    {
      "name": "Pune to Mahabaleshwar Swift Cab",
      "description": "Swift cabs from Pune to Mahabaleshwar for quick and smooth travel. Suitable for solo or duo travelers looking for a budget and comfortable option."
    }
  ],
  "tableData": [
    ["Pune to Mahabaleshwar Innova Crysta Cab", "Pune to Mahabaleshwar Taxi"],
    ["Pune to Mahabaleshwar Cab Package", "Pune to Mahabaleshwar Cab for 2 Days"],
    ["Pune to Mahabaleshwar Cab Service", "Pune to Mahabaleshwar Car"],
    ["Pune to Mahabaleshwar Etios Taxi Fare", "Pune to Mahabaleshwar Innova Cab"],
    ["Pune to Mahabaleshwar Dzire Cab", "Pune to Mahabaleshwar Round Trip Taxi"],
    ["Pune to Mahabaleshwar One Way Cab", "Pune to Mahabaleshwar Family Cab"],
    ["Pune to Mahabaleshwar Affordable Taxi", "Pune to Mahabaleshwar Swift Cab"]
  ],


    "whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Mahabaleshwar Cab Service",
    "WhyChoosedescription": "Prince Cabs offers reliable and comfortable cab services from Pune to Mahabaleshwar, perfect for weekend getaways, family vacations, or business travel. Enjoy the scenic drive with our well-maintained vehicles and professional drivers who ensure a safe and punctual journey. With flexible booking options, transparent pricing, and 24/7 support, your travel to Mahabaleshwar is smooth and hassle-free with Prince Cabs."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghat and Hill Travel",
    "WhyChoosedescription": "Our drivers are highly experienced in handling ghat sections and hilly terrain between Pune and Mahabaleshwar. They prioritize safety, drive cautiously through sharp turns, and ensure you enjoy a relaxing ride with minimal motion discomfort."
  },
  {
    "WhyChooseheading": "Wide Range of Cabs for Every Travel Need",
    "WhyChoosedescription": "From budget-friendly sedans to spacious Innovas and Crystas, Prince Cabs offers multiple vehicle options for your Pune to Mahabaleshwar trip. Whether you're a solo traveler, couple, family, or group, we have the right cab to fit your comfort and budget."
  },
  {
    "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs undergo regular cleaning and maintenance checks. For the Pune to Mahabaleshwar route, we ensure our vehicles are ready for long-distance travel with hygiene, safety, and comfort as top priorities."
  },
  {
    "WhyChooseheading": "Affordable One-Way and Round Trip Packages",
    "WhyChoosedescription": "We offer cost-effective one-way and round-trip cab packages from Pune to Mahabaleshwar. No hidden charges, flexible return options, and transparent billing make us the preferred choice for outstation travelers."
  },
  {
    "WhyChooseheading": "Doorstep Pickup and On-Time Service",
    "WhyChoosedescription": "Prince Cabs ensures timely doorstep pickup from anywhere in Pune. We value your time and maintain strict punctuality so that your journey to Mahabaleshwar starts and ends exactly as planned."
  },
  {
    "WhyChooseheading": "Easy Booking via Call, WhatsApp, or Online",
    "WhyChoosedescription": "Booking a Pune to Mahabaleshwar cab is quick and convenient with Prince Cabs. Choose your preferred mode—call, WhatsApp, or website—and our team will confirm your ride instantly with all trip details."
  }
]


















    }

const faqData = [
  {
    question: 'Does Prince Cabs provide Pune to Mahabaleshwar cab service?',
    answer: 'Yes, Prince Cabs offers reliable Pune to Mahabaleshwar cab services for one-way, round trip, or multi-day travel with experienced drivers and well-maintained vehicles.',
  },
  {
    question: 'What types of vehicles are available for the Pune to Mahabaleshwar route?',
    answer: 'We offer a range of cars including Dzire, Etios, Innova, and Innova Crysta for comfortable travel based on your group size and budget.',
  },
  {
    question: 'Can I book a round trip cab from Pune to Mahabaleshwar?',
    answer: 'Absolutely. Prince Cabs offers round trip packages with flexible return options. You can plan your return on the same day or after a stay in Mahabaleshwar.',
  },
  {
    question: 'Is there an option for a two-day cab package to Mahabaleshwar?',
    answer: 'Yes, we provide 2-day cab packages that include waiting charges and local sightseeing in and around Mahabaleshwar.',
  },
  {
    question: 'How do I book a Pune to Mahabaleshwar cab with Prince Cabs?',
    answer: 'You can book easily via call, WhatsApp, or through our website. Just share your travel date, pickup point, and preferred cab type, and we’ll confirm your booking instantly.',
  },
  {
    question: 'Are the cabs sanitized and drivers trained for long trips?',
    answer: 'Yes, all our cabs are regularly cleaned and sanitized. Our drivers are experienced in long-distance routes like Pune to Mahabaleshwar and follow all safety protocols.',
  },
  {
    question: 'What are the charges for a Pune to Mahabaleshwar cab?',
    answer: 'Cab fares vary depending on the car type, trip duration (one-way/round trip), and travel dates. Contact us for a detailed fare estimate based on your travel plan.',
  }
];
const testimonials = [
  {
    name: "Mr. Rajesh Deshmukh",
    position: "Weekend Traveler",
    text: "I booked a Pune to Mahabaleshwar cab with Prince Cabs for a weekend trip. The car was clean, the driver was polite, and the journey was very smooth. Highly recommend their service!",
    image: "/img/testimonial/testimonial-thumb-mahabaleshwar-1.png",
  },
  {
    name: "Mrs. Anjali Patil",
    position: "Family Vacationer",
    text: "Our family used Prince Cabs for a 2-day Mahabaleshwar trip. The Innova was spacious and comfortable, and the driver helped us with sightseeing spots too. Great experience overall!",
    image: "/img/testimonial/testimonial-thumb-mahabaleshwar-2.png",
  }
];
























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cab",
  "image": "https://princecab.com/assets/images/pune-mahabaleshwar-cab.jpg",
  "description": "Book Pune to Mahabaleshwar cab service with Prince Cabs for a comfortable, affordable, and reliable taxi ride. Options include AC sedans, SUVs, and round trip packages. 24/7 booking available online.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "7125"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-mahabaleshwar-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Mahabaleshwar Cab | Affordable & Safe Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Book Pune to Mahabaleshwar cab with Prince Cabs – Safe, affordable, and reliable taxi options including Innova Crysta, Dzire, and Etios. One-way and round trip packages available. 24/7 online booking."
  />
  <meta
    name="keywords"
    content="Pune to Mahabaleshwar Cab, Pune to Mahabaleshwar Innova Crysta Cab, Pune to Mahabaleshwar Taxi, Pune to Mahabaleshwar Cab Package, Pune to Mahabaleshwar Cab for 2 Days, Pune to Mahabaleshwar Cab Service, Pune to Mahabaleshwar Car, Pune to Mahabaleshwar Etios Taxi Fare, Pune to Mahabaleshwar Innova Cab, Pune to Mahabaleshwar Dzire Cab, Pune to Mahabaleshwar Round Trip Taxi, Pune to Mahabaleshwar One Way Cab, Pune to Mahabaleshwar Family Cab, Pune to Mahabaleshwar Affordable Taxi, Pune to Mahabaleshwar Swift Cab"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwar ;